import { routerFrom } from "router";

export const routes = [
  {
    acl: ["ADMIN", "MANAGER"],
    label: "Work Orders Detail",
    name: "work-orders.detail",
    path: "/app/work-orders/:workOrderId",
    testName: "work-order-details",
  },
];

export const router = routerFrom(routes);
